import React from "react";
import { string, oneOfType, number, objectOf, object, shape, array } from "prop-types";
import cx from "classnames";
// eslint-disable-next-line import/no-cycle
import { Card } from "../../../sharedComponents/Card";
import * as styles from "./SenaryCard.module.scss";

const SenaryCard = ({ image, header, link, className, style }) => (
	<Card className={cx(styles.senary, className)} style={style}>
		{image && (
			<Card.Image
				className={cx(styles.image)}
				src={!image.srcSet && image.src}
				source={image.srcSet && image}
				alt={image.alt}
				fluid={image.fluid}
			/>
		)}
		<Card.BodyContainer className={cx(styles.contentContainer)}>
			<Card.Header className={cx(styles.heading)}>{header}</Card.Header>
			<Card.Link
				className={cx(styles.link)}
				to={link?.to ?? ""}
				target={link?.target ?? "_blank"}
				iconSize="swg-text-xs">
				<span className={cx(styles.linkText)}>{link?.text ?? ""}</span>
			</Card.Link>
		</Card.BodyContainer>
	</Card>
);

SenaryCard.propTypes = {
	image: shape({
		fluid: oneOfType([object, array]),
		fixed: oneOfType([object, array]),
		source: shape({
			src: string,
			srcSet: string,
			sizes: string,
		}),
		alt: string,
		src: string,
	}).isRequired,
	header: string.isRequired,
	link: shape({
		to: string.isRequired,
		target: string,
		icon: shape({
			svg: shape({
				content: string,
			}),
		}),
		text: string,
	}).isRequired,
	className: string,
	style: objectOf(oneOfType([string, number])),
};

SenaryCard.defaultProps = {
	className: "",
	style: {},
};

export default SenaryCard;
export { SenaryCard };
